import React from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import keepers from "../data/keepers";
import episodes from "../data/episodes";
import "./KeepersPage.css";

export default function KeepersPage() {
  const { keeperId } = useParams();
  const navigate = useNavigate();

  // Default to first keeper if no ID in URL
  const currentKeeper =
    keepers.find((k) => k.id === keeperId) ?? keepers[0];

  const keeperEpisodes = episodes.filter((ep) =>
    currentKeeper.episodeIds.includes(ep.id)
  );

  return (
    <div className="keepers-page">
      {/* Header */}
      <header className="keepers-header">
        <div className="keepers-header-top">
          <Link to="/" className="back-link">
            ← Episodes
          </Link>
          <div className="keepers-header-text">
            <h1 className="site-title">Kingdom of Night</h1>
            <p className="site-tagline">Meet the Keepers</p>
          </div>
        </div>
      </header>

      {/* Keeper selector */}
      <nav className="keeper-nav" aria-label="Select a Keeper">
        <div className="keeper-pills">
          {keepers.map((k) => (
            <Link
              key={k.id}
              to={`/keepers/${k.id}`}
              className={`keeper-pill${k.id === currentKeeper.id ? " active" : ""}`}
            >
              {k.name.replace(/^The /, "")}
            </Link>
          ))}
        </div>
      </nav>

      {/* Bio */}
      <section className="keeper-bio">
        <div className="keeper-portrait-wrap">
          <img
            src={currentKeeper.imageUrl}
            alt={currentKeeper.name}
            className="keeper-portrait"
          />
        </div>
        <div className="keeper-bio-text">
          <h2 className="keeper-name">{currentKeeper.name}</h2>
          <p className="keeper-description">{currentKeeper.bio}</p>
        </div>
      </section>

      {/* Episodes */}
      {keeperEpisodes.length > 0 && (
        <section className="keeper-episodes">
          <h3 className="keeper-episodes-heading">Episodes</h3>
          <div className="keeper-episodes-list">
            {keeperEpisodes.map((ep) => (
              <div key={ep.id} className="keeper-episode-card">
                <div className="keeper-episode-meta">
                  <span className="card-theme">{ep.theme}</span>
                  <span className="keeper-episode-duration">{ep.duration}</span>
                </div>
                <h4 className="keeper-episode-title">{ep.title}</h4>
                <p className="keeper-episode-description">{ep.description}</p>
                <button
                  className="keeper-episode-cta"
                  onClick={() =>
                    navigate("/", { state: { playEpisodeId: ep.id } })
                  }
                >
                  Enter →
                </button>
              </div>
            ))}
          </div>
        </section>
      )}

      <footer className="site-footer">
        <p>The Kingdom does not close its gates.</p>
      </footer>
    </div>
  );
}
